import { render, staticRenderFns } from "./editRolePage.vue?vue&type=template&id=4d497f63&scoped=true&"
import script from "./editRolePage.vue?vue&type=script&lang=js&"
export * from "./editRolePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d497f63",
  null
  
)

export default component.exports